<template>
    <div class="row">
        <div class="col">
            <div class="form-group">
                <label>{{'Edit phone' | trans}}</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fa fa-phone"></i></span>
                    </div>
                    <input v-model.trim="newNumber" class="form-control" :v="$v.newNumber"
                           :class="status($v.newNumber)">
                    <ul class="phone__messages invalid-feedback list-unstyled" v-if="$v.newNumber.$error">
                        <li v-if="!$v.newNumber.error">
                            {{'Phone should' | trans}}
                            <span v-if="!$v.newNumber.required">
                                    {{'be required' | trans}}
                                </span>
                            <span v-if="!$v.newNumber.numeric">
                                    {{'contain only digits' | trans}}
                                </span>
                            <span v-if="!$v.newNumber.mustBeginsWithTwoZero">
                                    {{'start with "00"' | trans}}
                                </span>
                            <span v-if="!$v.newNumber.minLength">
                                    {{'be' | trans}} {{phoneLength}} {{'symbols long' | trans}}
                                </span>
                            <span v-if="!$v.newNumber.mustDiffOld">
                                    {{'be' | trans}} {{'diff from old' | trans}}
                                </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group">
                <b-button class="btn-success" @click="updateNumber">
                    {{'Save' | trans}}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    const {required, minLength, maxLength, integer, numeric, requiredIf} = require('vuelidate/lib/validators');
    import {validationMixin} from 'vuelidate';

    const mustBeginsWithTwoZero = (value) => {
        if (typeof value === 'undefined' || value === null || value === '') {
            return true
        }
        return /^00.*$/.test(value)
    };
    const mustDiffOld = function (value) {
        return value !== this.pNumbers[this.type]
    };
    export default {
        name: "editSecondaryPhone",
        mixins: [validationMixin],
        props: {
            pNumbers: {type: Object, required: true},
            type: {type: String, required: true},
            countryId: {type: String, required: true},
            cbPartnerId: {type: String, required: true},
            route: {type: String, required: true},
        },
        data() {
            return {
                newNumber: null,
                phoneLength: 14,
            }
        },
        methods: {
            updateNumber() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
                    let request = {};
                    request[this.type] = this.newNumber;
                    request.cbPartnerId = this.cbPartnerId;
                    axios.post(this.route, request).then((response) => {
                        this.$emit('updated', response.data)
                        this.EventBus.$emit('event-success', Lang.get('Success'));
                    }).catch(() => {
                        this.$emit('updated', false)
                    });
                }
            }
        },
        mounted() {
            this.newNumber = this.pNumbers[this.type];
            if (this.countryId) {
                switch (this.countryId) {

                    case ('198')://GUINÉE
                    case ('297')://SÉNÉGAL
                        this.phoneLength = 14;
                        break;
                    case ('109')://CANADA
                    case ('162')://COTE D'IVOIRE
                    case ('102')://FRANCE
                    case ('208')://India
                    case ('240')://MALI
                    case ('100')://USA
                    default:
                        this.phoneLength = 13;
                        break;
                }
            }
        },
        validations() {
            let v = {
                newNumber: {
                    required,
                    minLength: minLength(this.phoneLength),
                    numeric,
                    mustBeginsWithTwoZero,
                    mustDiffOld
                }

            };

            return v;
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/editSecondaryPhone.vue